import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "contactDetailsContainer" };
const _hoisted_2 = {
    key: 0,
    class: "flex flex-row items-center py-2"
};
const _hoisted_3 = { class: "flex w-[88%] flex-col leading-3 pl-3" };
const _hoisted_4 = {
    class: "text-sm font-medium leading-5 cursor-pointer",
    id: "contact-details-container"
};
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("div", { class: "w-[12rem] overflow-hidden truncate text-ellipsis capitalize mt-1 text-xs" }, " Appointment Owner ", -1 /* HOISTED */);
const _hoisted_6 = {
    key: 4,
    class: "flex flex-row items-center"
};
const _hoisted_7 = { class: "flex w-[88%] flex-col leading-3 pl-3" };
const _hoisted_8 = {
    class: "text-sm font-medium leading-5",
    id: "contact-details-container"
};
import Contact from '@/models/contact';
import AppState, { getTargetTimezone } from '@/states/view_appointment';
import { User01Icon } from '@gohighlevel/ghl-icons/24/outline';
import { UIAvatar } from '@gohighlevel/ghl-ui';
import { computed } from 'vue';
import UserDetails from '../common/UserDetails.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AppointmentUsers',
    props: {
        isClassBookingView: Boolean,
        router: Object,
        showAppointmentOwner: Boolean,
    },
    setup(__props) {
        // Computed property to get the contact guest details based on the appointment type
        const guestInfo = computed(() => {
            var _a, _b, _c, _d;
            // Check if the appointmentDetails and eventType properties exist and eventType is 'google'
            if (((_a = AppState.appointmentDetail) === null || _a === void 0 ? void 0 : _a.eventType) === 'google') {
                const guests = (_b = AppState.appointmentDetail) === null || _b === void 0 ? void 0 : _b.guests;
                const contacts = guests === null || guests === void 0 ? void 0 : guests.map(item => new Contact(item));
                return contacts ? contacts.map(contact => contact) : [];
            }
            else if (((_c = AppState.appointmentDetail) === null || _c === void 0 ? void 0 : _c.eventType) === 'outlook') {
                const guests = (_d = AppState.appointmentDetail) === null || _d === void 0 ? void 0 : _d.guests;
                const contacts = guests === null || guests === void 0 ? void 0 : guests.map((item) => {
                    var _a, _b, _c, _d;
                    return new Contact({
                        email: (_a = item.emailAddress) === null || _a === void 0 ? void 0 : _a.address,
                        name: (_b = item.emailAddress) === null || _b === void 0 ? void 0 : _b.name,
                        initials: (_d = (_c = item.emailAddress) === null || _c === void 0 ? void 0 : _c.name) === null || _d === void 0 ? void 0 : _d.charAt(0).toUpperCase(),
                    });
                });
                return contacts ? contacts.map(contact => contact) : [];
            }
            return AppState.guestsDetails;
        });
        const contactInfo = computed(() => {
            return [AppState.contactDetails];
        });
        const targetTimezone = computed(() => {
            return getTargetTimezone();
        });
        // Computed property to filter the appointment list
        const filteredAppointmentList = computed(() => {
            // Retrieve the appointmentAttendees array from the props
            const appointments = AppState.appointmentsRef;
            const appointmentsData = [];
            // Use the reduce method to iterate over the appointments array and accumulate the data in appointmentsData
            return appointments.reduce((acc, cur) => {
                acc.push(cur);
                return acc;
            }, appointmentsData);
        });
        const showPrimaryUserDetails = computed(() => {
            var _a;
            return ((_a = AppState.appointmentDetail) === null || _a === void 0 ? void 0 : _a.eventType) === 'appt' ? true : false;
        });
        return (_ctx, _cache) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
            return (_openBlock(), _createElementBlock("div", null, [
                _createElementVNode("div", _hoisted_1, [
                    (__props.showAppointmentOwner && _unref(AppState).appointmentOwnerDetails)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            ((_a = _unref(AppState).appointmentOwnerDetails) === null || _a === void 0 ? void 0 : _a.profilePicture)
                                ? (_openBlock(), _createBlock(_unref(UIAvatar), {
                                    key: 0,
                                    src: (_b = _unref(AppState).appointmentOwnerDetails) === null || _b === void 0 ? void 0 : _b.profilePicture
                                }, null, 8 /* PROPS */, ["src"]))
                                : ((_c = _unref(AppState).appointmentOwnerDetails) === null || _c === void 0 ? void 0 : _c.name)
                                    ? (_openBlock(), _createBlock(_unref(UIAvatar), {
                                        key: 1,
                                        style: _normalizeStyle({
                                            color: 'var(--gray-600)',
                                            backgroundColor: 'var(--gray-100)',
                                        })
                                    }, {
                                        default: _withCtx(() => {
                                            var _a;
                                            return [
                                                _createTextVNode(_toDisplayString((_a = _unref(AppState).appointmentOwnerDetails) === null || _a === void 0 ? void 0 : _a.name.charAt(0).toUpperCase()), 1 /* TEXT */)
                                            ];
                                        }),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["style"]))
                                    : (_openBlock(), _createBlock(_unref(UIAvatar), {
                                        key: 2,
                                        class: "bg-gray-100"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_unref(User01Icon), { class: "w-5 h-5 text-gray-700" })
                                        ]),
                                        _: 1 /* STABLE */
                                    })),
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_4, _toDisplayString((_d = _unref(AppState).appointmentOwnerDetails) === null || _d === void 0 ? void 0 : _d.name), 1 /* TEXT */),
                                    _hoisted_5
                                ])
                            ])
                        ]))
                        : _createCommentVNode("v-if", true),
                    _createCommentVNode(" Conditionally render the UserDetails component if there are contact guest details and no appointment attendees "),
                    (showPrimaryUserDetails.value &&
                        _unref(AppState).contactDetails &&
                        ((_e = _unref(AppState).appointmentsRef) === null || _e === void 0 ? void 0 : _e.length) == 0)
                        ? (_openBlock(), _createBlock(UserDetails, {
                            key: 1,
                            contacts: contactInfo.value,
                            "booked-by": (_f = _unref(AppState).appointmentDetail) === null || _f === void 0 ? void 0 : _f.bookedBy,
                            source: (_g = _unref(AppState).appointmentDetail) === null || _g === void 0 ? void 0 : _g.source,
                            "user-details": _unref(AppState).userDetails,
                            router: __props.router,
                            "user-type": 'Primary Contact',
                            "show-menu": showPrimaryUserDetails.value,
                            "appointment-details": _unref(AppState).appointmentDetail,
                            "target-timezone": targetTimezone.value
                        }, null, 8 /* PROPS */, ["contacts", "booked-by", "source", "user-details", "router", "show-menu", "appointment-details", "target-timezone"]))
                        : _createCommentVNode("v-if", true),
                    _createCommentVNode(" Conditionally render the UserDetails component if there are appointment attendees "),
                    (((_h = _unref(AppState).appointmentsRef) === null || _h === void 0 ? void 0 : _h.length) > 0)
                        ? (_openBlock(), _createBlock(UserDetails, {
                            key: 2,
                            appointments: filteredAppointmentList.value,
                            router: __props.router,
                            timezone: _unref(AppState).timezone,
                            "user-details": _unref(AppState).userDetails,
                            "user-type": "Contact",
                            "show-menu": showPrimaryUserDetails.value,
                            "target-timezone": targetTimezone.value
                        }, null, 8 /* PROPS */, ["appointments", "router", "timezone", "user-details", "show-menu", "target-timezone"]))
                        : _createCommentVNode("v-if", true),
                    (guestInfo.value.length > 0 && ((_j = _unref(AppState).appointmentsRef) === null || _j === void 0 ? void 0 : _j.length) == 0)
                        ? (_openBlock(), _createBlock(UserDetails, {
                            key: 3,
                            contacts: guestInfo.value,
                            "booked-by": (_k = _unref(AppState).appointmentDetail) === null || _k === void 0 ? void 0 : _k.bookedBy,
                            source: (_l = _unref(AppState).appointmentDetail) === null || _l === void 0 ? void 0 : _l.source,
                            "user-details": _unref(AppState).userDetails,
                            "user-type": 'Guest',
                            router: __props.router,
                            "show-menu": showPrimaryUserDetails.value,
                            "target-timezone": targetTimezone.value
                        }, null, 8 /* PROPS */, ["contacts", "booked-by", "source", "user-details", "router", "show-menu", "target-timezone"]))
                        : _createCommentVNode("v-if", true),
                    ((_m = _unref(AppState).appointmentDetail) === null || _m === void 0 ? void 0 : _m.guestCount)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createVNode(_unref(UIAvatar), { class: "bg-gray-100" }, {
                                default: _withCtx(() => [
                                    _createVNode(_unref(User01Icon), { class: "w-5 h-5 text-gray-700" })
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("div", null, [
                                    _createElementVNode("div", _hoisted_8, " +" + _toDisplayString((_o = _unref(AppState).appointmentDetail) === null || _o === void 0 ? void 0 : _o.guestCount) + " guests ", 1 /* TEXT */)
                                ])
                            ])
                        ]))
                        : _createCommentVNode("v-if", true)
                ])
            ]));
        };
    }
});
